import * as fromDatatype from '../datatype-library';

export interface bl_fi_mst_item_price_listing_import_file_helper_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
  short_error_message: fromDatatype.VarcharDatatypeInterface;
  error_stack_trace: fromDatatype.VarcharDatatypeInterface;
  validated: boolean;
  processed: boolean;
  revision: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: any;
  acl_policy: any;
  property_json: any;
  vrsn: fromDatatype.VarcharDatatypeInterface;

  //other fields
  pricing_scheme_code: fromDatatype.VarcharDatatypeInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  sales_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  min_sales_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  min_sales_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  min_sales_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  max_sales_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  max_sales_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  max_sales_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_price_before_discount_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_price_before_discount_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_price_before_discount_tax_amt: fromDatatype.NumericDatatypeInterface;
  output_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_wht_code: fromDatatype.VarcharDatatypeInterface;
  purchase_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  min_purchase_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  min_purchase_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  min_purchase_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  max_purchase_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  max_purchase_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  max_purchase_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  input_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_wht_code: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_mst_item_price_listing_import_file_helper_RowClass implements bl_fi_mst_item_price_listing_import_file_helper_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
  short_error_message: fromDatatype.VarcharDatatypeInterface;
  error_stack_trace: fromDatatype.VarcharDatatypeInterface;
  validated: boolean;
  processed: boolean;
  revision: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: any;
  acl_policy: any;
  property_json: any;
  vrsn: fromDatatype.VarcharDatatypeInterface;

  //other fields
  pricing_scheme_code: fromDatatype.VarcharDatatypeInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  sales_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  min_sales_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  min_sales_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  min_sales_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  max_sales_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  max_sales_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  max_sales_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_price_before_discount_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_price_before_discount_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_price_before_discount_tax_amt: fromDatatype.NumericDatatypeInterface;
  output_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_wht_code: fromDatatype.VarcharDatatypeInterface;
  purchase_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  min_purchase_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  min_purchase_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  min_purchase_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  max_purchase_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  max_purchase_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  max_purchase_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  input_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_wht_code: fromDatatype.VarcharDatatypeInterface;
}